import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/** Date format the turn4-api IDP endpoints use for params, keys and `revealSeenDate`. */
export const IDP_API_DATE_FORMAT = 'YYYYMMDD';

export function toIdpApiDate(date: Dayjs): string {
  return date.format(IDP_API_DATE_FORMAT);
}

/** Strict yyyyMMdd parse; `undefined` for anything else. */
export function parseIdpApiDate(value: string | null | undefined): Dayjs | undefined {
  if (!value) return undefined;
  const parsed = dayjs(value, IDP_API_DATE_FORMAT, true);
  return parsed.isValid() ? parsed : undefined;
}

/**
 * Inclusive yyyyMMdd range covering the last `days` days, ending today on the browser clock.
 * The timeline endpoint rejects ranges spanning more than 90 days and start dates in the future.
 */
export function getLastDaysIdpRange(
  days: number,
  today: Dayjs = dayjs(),
): {
  startDate: string;
  endDate: string;
} {
  const end = today.startOf('day');
  return {
    startDate: toIdpApiDate(end.subtract(days - 1, 'day')),
    endDate: toIdpApiDate(end),
  };
}
